import React from "react";

function ProjectArea() {
  const imageHandler = () => {
    const els = document.querySelectorAll(".collapse-anim");
    els.forEach((item) => {
      const height = item.scrollHeight;
      item.style.setProperty("--max-height", `${height}px`);
    });
  };
  return (
    <section
      className="project-area project-bg"
      // style={{
      //   backgroundImage: `url(${require("../../assets/img/bg/project_bg.jpg")})`,
      // }}
    >
      <div className="container">
        <div className="row align-items-end">
          <div className="col-lg-8">
            <div className="section-title white-title mb-50 tg-heading-subheading animation-style3">
              <span className="sub-title tg-element-title">
                Latest Projects
              </span>
              <h2 className="title tg-element-title">
                Explore Our Latest Projects
              </h2>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="view-all-btn text-end mb-50">
              <a href="/project/project-roof" className="btn">
                View All Projects
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="project-item wow fadeInUp" data-wow-delay=".2s">
              <div className="project-thumb collapse-anim">
                <img
                  src={require(`../../assets/img/project/project_img01c.jpg`)}
                  onLoad={imageHandler}
                  alt=""
                />
              </div>
              <div className="project-content">
                <div className="left-side-content">
                  <span>March 2024</span>
                  <h2 className="title">
                    <a href="/project-details">
                      Roof Replacement
                    </a>
                  </h2>
                  <p className="collapse-anim">
                  Our team specializes in complete roof replacement projects, using only the highest quality materials and advanced installation techniques to ensure a durable and long-lasting roof.
                  </p>
                </div>
                <div className="project-link">
                  <a href="/project/project-roof">
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="project-item wow fadeInUp" data-wow-delay=".3s">
              <div className="project-thumb collapse-anim">
                <img
                  src={require(`../../assets/img/project/project_img02c.jpg`)}
                  onLoad={imageHandler}
                  alt=""
                />
              </div>
              <div className="project-content">
                <div className="left-side-content">
                  <span>January 2024</span>
                  <h2 className="title">
                    <a href="#">Siding Installation</a>
                  </h2>
                  <p className="collapse-anim">
                  Our skilled team offers professional siding installation services, including various materials and styles. We specialize in creating beautiful and durable exteriors that enhance your home's curb appeal.
                  </p>
                </div>
                <div className="project-link">
                  <a href="/project/project-siding">
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="project-item wow fadeInUp" data-wow-delay=".4s">
              <div className="project-thumb collapse-anim">
                <img
                  src={require(`../../assets/img/project/project_img03.jpg`)}
                  onLoad={imageHandler}
                  alt=""
                />
              </div>
              <div className="project-content">
                <div className="left-side-content">
                  <span>Octuber 2023</span>
                  <h2 className="title">
                    <a href="#">
                      Gutter Installation
                    </a>
                  </h2>
                  <p className="collapse-anim">
                  Our expert team provides precise gutter installation services, ensuring proper water drainage and protecting your home from damage.
                  </p>
                </div>
                <div className="project-link">
                  <a href="/project/project-gutter">
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            {/* <div className="project-item wow fadeInUp" data-wow-delay=".5s">
              <div className="project-thumb collapse-anim">
                <img
                  src={require(`../../assets/img/project/project_img04.jpg`)}
                  onLoad={imageHandler}
                  alt=""
                />
              </div>
              <div className="project-content">
                <div className="left-side-content">
                  <span>Projects V3</span>
                  <h2 className="title">
                    <a href="#">
                      Low Rise Building and Repair Roof
                    </a>
                  </h2>
                  <p className="collapse-anim">
                    There are many variations of passages of Lorem Ipsum ava
                    have suffered alteration in some form, by injected humour
                    which don't look even slightly believable.
                  </p>
                </div>
                <div className="project-link">
                  <a href="#">
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProjectArea;
